import React, {ReactElement, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useAppSelector} from '../../redux/hooks';
import Modal from '../../components/modal/Modal';
import {
  fetchPromo,
  promoResponse,
  error,
  loading,
} from '../../redux/instore-promotionsSlice';
import {getStoreInformation} from '../../core/localstorage-data';
import {storeInformation} from '../../redux/storeInformationSlice';
import {bannerDetailGtmData} from '../../lib/tagmanager';
import {bannerDetailInfo, bannerType} from '../../lib/types';

import {bannerEvent, eventNames} from '../../lib/constants';

export const Getbanner = () => {
  const [promotions, setPromotions] = useState(false);
  const [promotionsSelected, setPromotionsSelected] = useState(false);
  const [banners, setBanners] = useState<bannerType[] | []>([]);
  const [selectedBanner, setSelectedBanner] = useState<bannerType | null>(null);
  const dispatch = useDispatch();
  const promoData = useAppSelector(promoResponse);
  const promoHasError = useAppSelector(error);
  const promoHasLoaded = useAppSelector(loading);
  const storeInfomation = getStoreInformation();

  useEffect(() => {
    dispatch(fetchPromo());
  }, []);
  console.log(promotions);

  useEffect(() => {
    if (promoHasLoaded == false) {
      setPromotions(true);
      console.log('here is data');
      console.log(promoData);
    }
  }, [promoHasError, promoHasLoaded, promoData]);

  useEffect(() => {
    if (promoData.images) {
      const bannerList = Object.keys(promoData.images)
        .filter(img => !img.endsWith('_content'))
        .map(img => ({
          src: promoData.images[img],
          content: promoData.images[`${img}_content`],
        }));
      setBanners(bannerList);
    }
  }, [promoData]);

  const bannerClickHandler = (item: bannerType) => {
    setSelectedBanner(item);
    if (item != null) {
      //console.log(selectedBanner,"selected banner data");
      const bannerFilter = (item?.content).lastIndexOf('/') + 1;
      const bannerNameWithExtension = (item?.content).slice(bannerFilter);
      const bannerNameWithoutExtension = bannerNameWithExtension.split('.');
      const BannerDetail: bannerDetailInfo = {
        bannerId: bannerNameWithoutExtension[0].toString(),
        eventName: eventNames.inStoreEvent,
        event: bannerEvent,
      };
      bannerDetailGtmData(BannerDetail);
    }
    setPromotionsSelected(true);
  };

  // {promotions?(<div >
  // {/* {obj.map(item)=>{console.log(item.value)}} */}
  // <img src={(obj.map(item=>(item.value))).toString()} " />
  // </div>):''}
  return (
    <div className="grid place-items-center">
      <div>
        {banners.length > 0
          ? banners.map((item, index) => (
              <div key={index}>
                <img
                  className="w-full mt-4 h-40 rounded-xl"
                  src={item.src}
                  onClick={() => bannerClickHandler(item)}
                />
              </div>
            ))
          : ''}
      </div>
      {promotionsSelected ? (
        <Modal
          title=""
          isVisible={promotionsSelected == true}
          onModalClosed={() => {
            setPromotionsSelected(false);
          }}>
          <div className="w-full h-auto pl-8 pr-8">
            <img
              src={selectedBanner ? selectedBanner.content : undefined}
              className="w-auto h-auto rounded-xl"
              alt="Banner"
            />
          </div>
        </Modal>
      ) : (
        ''
      )}
    </div>
  );
};
